'use strict';
import {ListCtrl} from '../lmtdb/listctrl.js';
import {thesisModel} from '../../models/thesismodel.js';

export class DisertacijosListSiteCtrl extends ListCtrl {
    storageNames = {query: 'DisertacijosListSiteQuery'};

    constructor($scope, $http, $filter, $timeout, $locale, jsDataService) {
        super($scope, $http, $filter, $timeout, $locale, jsDataService);

        const g = (typeof window !== 'undefined') ? window : {};
        this.jsDataService.data.cfgAppName = g.cfgAppName || this.jsDataService.data.cfgAppName || '';
        this.jsDataService.data.cfgDataUrl = g.cfgDataUrl || this.jsDataService.data.cfgDataUrl || 'listdata';
        this.jsDataService.data.cfgExportUrl = g.cfgExportUrl || this.jsDataService.data.cfgExportUrl || '';
        this.jsDataService.data.cfgQueryStorageKey = g.cfgQueryStorageKey || this.jsDataService.data.cfgQueryStorageKey || 'DisertacijosListSiteQuery';
        this.jsDataService.data.cfgQuery = g.cfgQuery || this.jsDataService.data.cfgQuery || {};
        if (g.cfgClassif) this.jsDataService.data.cfgClassif = g.cfgClassif;

        if (g.cfgDisplayColumns) this.jsDataService.data.cfgDisplayColumns = g.cfgDisplayColumns;
        if (g.cfgFooterColumns) this.jsDataService.data.cfgFooterColumns = g.cfgFooterColumns;

        this.cfgExportUrl = this.jsDataService.get('cfgExportUrl', '');

        const key = this.jsDataService.get('cfgQueryStorageKey', '');
        if (key) this.storageNames.query = key;

        const q = this.jsDataService.get('cfgQuery', {}) || {};
        if (!q.filters) q.filters = {};

        if (!q.filters.institucija) q.filters.institucija = {field:'institucija', title:'Institucija', isChip:true, value:null};
        if (!q.filters.mkryptis)    q.filters.mkryptis    = {field:'mkryptis',    title:'Mokslo, meno kryptys', isChip:true, value:null};

        q.filters.institucija.type = 'classif';
        q.filters.institucija.classifName = 'institucijos';
        q.filters.mkryptis.type = 'classif';
        q.filters.mkryptis.classifName = 'kryptys';

        if (q.filters.institucija.value === 0) q.filters.institucija.value = null;
        if (q.filters.mkryptis.value === 0)    q.filters.mkryptis.value    = null;

        this.jsDataService.data.cfgQuery = q;

        this.classif = this.jsDataService.get('cfgClassif', {apginta:[], institucijos:[], kryptys:[]});
    }

    $onInit() {
        super.$onInit();

        const urlParams = new URLSearchParams(window.location.search);
        const instFromUrl = urlParams.get('institucija');
        const apgintaFromUrl = urlParams.get('apginta');

        if (instFromUrl || apgintaFromUrl !== null) {
            if (instFromUrl) {
                const instValue = parseInt(instFromUrl, 10);
                if (instValue > 0) {
                    this.query.filters.institucija.value = instValue;
                }
            }

            if (apgintaFromUrl !== null) {
                const apgintaValue = parseInt(apgintaFromUrl, 10);
                if (!isNaN(apgintaValue)) {
                    this.query.filters.apginta.value = [apgintaValue];
                }
            }
        }
    }

    setData(data) {
        this.data = [];
        for (let ln of data) this.data.push(new thesisModel(ln, this.$filter, this.jsDataService));
    }

    getColValue(row, col) {
        if (typeof row[col] === 'undefined') return '';
        if (row instanceof thesisModel) return row.getValue(col);
        return row[col];
    }

    getFooterData(col) {
        if (this.columnsData && this.columnsData.footer && typeof this.columnsData.footer[col] !== 'undefined') {
            return this.columnsData.footer[col].value;
        }
        return '';
    }
}
